import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useSelector } from "react-redux";
import { Button, Grid, Typography , Menu , MenuItem , TextField} from "@mui/material";
import {EditOutlined ,DeleteOutline , PersonSearch} from "@mui/icons-material";
import { ContentCopyOutlined, TableChartOutlined, DescriptionOutlined, PictureAsPdfOutlined, FileDownloadOutlined } from "@mui/icons-material";
import { DataGrid , GridToolbarContainer, GridToolbarDensitySelector, } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useLocation } from 'react-router-dom';
import moment from 'moment-timezone';

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

//Services
import passengerApi from "Services/Passenger";
import { CUSTOM_CONSTANTS } from "../../Constants";
import Passengerhistorydetails from "Pages/Modals/Passengerhistory/Moredetails";
import PassengerrequestDeleteDialog from "Pages/Modals/Passengerhistory/Delete";

const PassengerHistory= () => {
  const location = useLocation();
  const { passengerdata } = location.state || {};
  const classes = useStyles();
  const dispatch = useDispatch();
  const timezone = useSelector((state) => state.timezone.timezone);
  //

  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);  
  const [requestId, setrequestId] = useState("");
  const [currentRowData, setCurrentRowData] = useState({});

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openaction = Boolean(anchorEl);
  const handleClick = (event, rowData) => {
    setCurrentRowData(rowData);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseaction = () => {
    setAnchorEl(null);
  };
  //Modals
  const [moredetailsmodel, setmoredetailsModal] = useState(false);

  const handleOpenmoredetailsModal = (row) => {
    setrequestId(row?._id);
    setmoredetailsModal(true);
    setAnchorEl(null);
  };

  const handleClosemoredetailsModal = () => {
    setmoredetailsModal(false);
    getPassengers();
  };

  const [deleteridereqModal, setdeleteridereqModal] = useState(false);

  const handleOpenDeleteridereqModal = (row) => {
    setrequestId(row?._id);
    setdeleteridereqModal(true);
    setAnchorEl(null);
  };

  const handleCloseDeleteridereqModal = (row) => {
    setdeleteridereqModal(false);
    getPassengers();
  };
  // Get Passenger list api
  const getPassengers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      //console.log("fecthed datas--->",res.data);
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    const passenger_id = passengerdata._id;
    passengerApi.getPassengerrequesthistory({ passenger_id , page, limit: pageSize })
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

  const getallPassengers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      //console.log("fecthed datas--->",res.data);
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    const passenger_id = passengerdata._id;
    passengerApi.getPassengerrequesthistory({ passenger_id , page:1, limit: "unlimited" })
      .then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getPassengers();
    getallPassengers();
  }, [getPassengers]);

 const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All PassengershistoryList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };   

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const handleCopy = () => {
       // Define column widths
       const columnWidths = [5, 15, 25, 15, 15, 15 , 15 , 15 , 15]; // Adjust widths as needed
  
       // Helper function to pad text to the desired width
       const padText = (text, width) => {
         return (text ?? "").toString().padEnd(width, " ");
       };
       // Create table header
       const header = [
         padText("S.NO", columnWidths[0]),
         padText("Booking Id", columnWidths[1]),
         padText("User Name", columnWidths[2]),
         padText("Driver Name", columnWidths[3]),
         padText("Date Time", columnWidths[4]),
         padText("Status", columnWidths[5]),
         padText("Amount", columnWidths[6]),
         padText("Payment Mode", columnWidths[7]),
         padText("Payment Status", columnWidths[8]),
       ].join("");
     
       // Create table rows
       const rows = dataRows
         .map((row) =>
           [
             padText(row.sno, columnWidths[0]),
             padText(row.bookingId, columnWidths[1]),
             padText(row.username, columnWidths[2]),
             padText(row.drivername, columnWidths[3]),
             padText(row.date_time, columnWidths[4]),
             padText(row.status, columnWidths[5]),
             padText(row.amount, columnWidths[6]),
             padText(row.paymentmode, columnWidths[7]),
             padText(row.paymentstatus, columnWidths[8]),
           ].join("")
         )
         .join("\n");
     
       // Combine header and rows
       const formattedContent = [header, rows].join("\n");
     
       // Copy to clipboard
       navigator.clipboard.writeText(formattedContent).then(() => {
         alert("Table copied to clipboard!");
       });

  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "passengerhistory.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "passengerhistory.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,row.bookingId,row.username,
      row.drivername,row.date_time,row.status,
      ,row.amount,row.paymentmode,row.paymentstatus,
    ]);
    doc.autoTable({
      head: [["S.NO","Booking Id","User Name","Driver Name","Date Time","Status","Amount","Payment Mode","Payment Status"]],
      body: tableData,
    });
    doc.save("passengerhistory.pdf");
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  function formatDate(inputDate) {
        if (!inputDate) {
          return "--"; // Return '--' if inputDate is null or undefined
        }
        
      return moment(inputDate).tz(timezone).format("YYYY-MM-DD hh:mm A");
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarDensitySelector />
      </GridToolbarContainer>
    );
  }

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    bookingId:data?.userRideRequestData.bookingId,
    username: data?.userRideRequestData.user_name,
    drivername:data?.driverName && Object.keys(data.driverName).length > 0? data?.driverName.firstName+" "+data?.driverName.lastName : "Not Found",
    date_time: formatDate(data?.userRideRequestData.createdAt),
    status:data?.userRideRequestData.tripStatus,
    amount:data?.userRideRequestData.isPaid ? 
           data?.userRideRequestData.estimatedFare+" "+CUSTOM_CONSTANTS.BASE_CURRENCY:"N/A",
    paymentmode:data?.userRideRequestData.paymentMode,
    paymentstatus:data?.userRideRequestData.isPaid?"PAID":"NOT PAID",
    row: data,
  }));

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "Booking Id":row.bookingId,
    "User Name":row.username,
    "Driver Name": row.drivername,
    "Date Time": row.date_time,
    "Status": row.status,
    "Amount": row.amount,
    "Payment Mode": row.paymentmode,
    "Payment Status": row.paymentstatus,
  }));
  
  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
     sno: calculateSno(page, pageSize, index),
    bookingId:data?.userRideRequestData.bookingId,
    username: data?.userRideRequestData.user_name,
    drivername:data?.driverName && Object.keys(data.driverName).length > 0? data?.driverName.firstName+" "+data?.driverName.lastName : "Not Found",
    date_time: formatDate(data?.userRideRequestData.createdAt),
    status:data?.userRideRequestData.tripStatus,
    amount:data?.userRideRequestData.isPaid ? 
           data?.userRideRequestData.estimatedFare+" "+CUSTOM_CONSTANTS.BASE_CURRENCY:"N/A",
    paymentmode:data?.userRideRequestData.paymentMode,
    paymentstatus:data?.userRideRequestData.isPaid?"PAID":"NOT PAID",
    row: data,
  }));  
  
  const bulkformatteddatas = bulkdataRows.map((row) => ({
      "S.NO": row.sno,
    "Booking Id":row.bookingId,
    "User Name":row.username,
    "Driver Name": row.drivername,
    "Date Time": row.date_time,
    "Status": row.status,
    "Amount": row.amount,
    "Payment Mode": row.paymentmode,
    "Payment Status": row.paymentstatus,
  }));  

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
    minWidth: 80, // Minimum column width
    resizable: true, // Allow users to resize
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "bookingId",
      headerName: "Booking Id",
    minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.bookingId}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "username",
      headerName: "User Name",
          minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.username}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "drivername",
      headerName: "Driver Name",
          minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.drivername}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "date_time",
      headerName: "Date Time",
          minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.date_time}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
          minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.status}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "amount",
      headerName: "Amount",
          minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.amount}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "paymentmode",
      headerName: "Payment Mode",
          minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.paymentmode}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "paymentstatus",
      headerName: "Payment Status",
          minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.paymentstatus}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
          minWidth: 150, // Minimum column width
    resizable: true, // Allow users to resize
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const rowData = params?.row?.row;
        return (
          <>
      <div className={classes.iconsWrapper}>
      <Button
        id="basic-button"
        aria-controls={openaction ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openaction ? 'true' : undefined}
        onClick={(e) => handleClick(e, rowData)}
      >
        Action
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openaction}
        onClose={handleCloseaction}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem  onClick={() =>
          handleOpenmoredetailsModal(currentRowData)
          }>
        <section className={classes.historyIcon}>
          <PersonSearch/>
          <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
          Moredetails
          </Typography>
          </section>
        </MenuItem >
        <MenuItem  onClick={() =>
          handleOpenDeleteridereqModal(currentRowData)
          }>
        <section className={classes.deleteIcon}>
          <DeleteOutline/>
          <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
          Delete
          </Typography>

          </section>
        </MenuItem>
      </Menu>
          </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Grid container className={classes.root}>
      <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<ContentCopyOutlined />} onClick={handleCopy}>
            COPY
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<TableChartOutlined />} onClick={handleDownloadExcel}>
            EXCEL
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<DescriptionOutlined />} onClick={handleDownloadCSV}>
            CSV
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<PictureAsPdfOutlined />} onClick={handleDownloadPDF}>
            PDF
          </Button>
        </Grid>
        <Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
                      <Button variant="contained" startIcon={<FileDownloadOutlined />} onClick={handleDownloadAll}>
                      Download ALL
                      </Button>
                      </Grid>  
        <Grid item xs={6} md={6} lg={6} xl={6} className={classes.addBtn}>
       
        </Grid>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px", overflowX: "auto" }}
              paginationMode="server"
              rowCount={totalPages}
              density="compact"
              components={{
                Toolbar: CustomToolbar,
              }}
            />
          </section>
        </Grid>
      </Grid>
      <Passengerhistorydetails
        openDialog={moredetailsmodel}
        id={requestId}
        handleClose={handleClosemoredetailsModal}
      ></Passengerhistorydetails>
      <PassengerrequestDeleteDialog
      openDialog={deleteridereqModal}
      id={requestId}
      handleClose={handleCloseDeleteridereqModal}
    ></PassengerrequestDeleteDialog>
    </>
  );
};

export default PassengerHistory;
